import { Injectable } from '@angular/core'
import { ParseService } from '../../parse.service'

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        snaptr?: any
    }
}

@Injectable({
    providedIn: 'root',
})
export class SnapPixelService {
    private loggedInUserEmail?: string
    private isInitiated = false

    constructor(private parseService: ParseService) {
        if (document.location.host !== 'app.wisepelican.com') {
            return
        }

        this.parseService.user.subscribe((loggedInUser) => {
            try {
                if (!window.snaptr) {
                    return
                }

                this.init(loggedInUser?.username)
            } catch (err) {
                this.parseService.reportUIError(err, 'SnapPixelService.Constructor.User.Subscribe', '')
            }
        })
    }

    private init(email: string | undefined) {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            if (!window.snaptr) {
                return
            }

            if (email !== this.loggedInUserEmail) {
                this.loggedInUserEmail = email

                if (!email) {
                    return
                }

                const pixelID = window.snaptr.pixelIdList?.[0]
                if (!pixelID) {
                    return
                }

                window.snaptr('init', pixelID, { user_email: email })
                this.isInitiated = true
            }
        } catch (err) {
            this.parseService.reportUIError(err, 'SnapPixelService.init', '')
        }
    }

    public trackPurchase(val: number, currency: 'USD') {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            if (!window.snaptr) {
                return
            }
            if (val <= 0) {
                return
            }

            if (!this.isInitiated) {
                this.init(this.loggedInUserEmail)
            }

            window.snaptr('track', 'PURCHASE', { price: val, currency, transaction_id: '' + Date.now() })
        } catch (err) {
            this.parseService.reportUIError(err, 'SnapPixelService.trackPurchase', '')
        }
    }

    public trackSignUp() {
        try {
            if (document.location.host !== 'app.wisepelican.com') {
                return
            }

            if (!window.snaptr) {
                return
            }

            if (!this.isInitiated) {
                this.init(this.loggedInUserEmail)
            }

            window.snaptr('track', 'SIGN_UP')
        } catch (err) {
            this.parseService.reportUIError(err, 'SnapPixelService.trackSignUp', '')
        }
    }
}
